import { Component, Input } from '@angular/core';
import { ILinkButtonTileDefinition } from '../../../../interfaces/tiles/definitions/link-button-tile.interface';
import { ITileComponent } from '../../tile-component.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-link-button-tile',
  templateUrl: './link-button-tile.component.html',
  styleUrls: ['./link-button-tile.component.scss'],
})
export class LinkButtonTileComponent implements ITileComponent {
  @Input() tileInstance: ILinkButtonTileDefinition;
}
